import React from 'react';
import cn from 'classnames';

import Checkbox from 'shared/ui/Checkbox/Checkbox';
import HintQuestion from 'shared/ui/Hint/HintQuestion';

import styles from './PremiumCheckbox.module.scss';

interface IPremiumCheckboxProps {
    label: string;
    helpText: string;
    register?: any;
    enabled: boolean;
    comingSoon?: boolean;
    disabled?: boolean;
}

const COMING_SOON_HINT
    = 'This feature is not available yet. We are working on it and plan to release it soon.';

const PremiumCheckbox: React.FC<IPremiumCheckboxProps> = ({
    label,
    helpText,
    register,
    enabled,
    comingSoon,
    disabled,
}) => {
    if (comingSoon) {
        return (
            <Checkbox textStyle={styles.checkbox} className={styles.opacity} disabled>
                {label}
                <HintQuestion placement="top-start">
                    <div>
                        <div>{COMING_SOON_HINT}</div>
                        {helpText}
                    </div>
                </HintQuestion>
            </Checkbox>
        );
    }

    if (enabled) {
        return (
            <Checkbox
                textStyle={styles.checkbox}
                className={cn(disabled && styles.opacity)}
                disabled={disabled}
                {...register}
            >
                {label}
                <HintQuestion placement="top-start">{helpText}</HintQuestion>
            </Checkbox>
        );
    }

    return (
        <div className={cn(styles.opacity, styles.checkbox)}>
            <span className={styles.label}>{label}</span>
            <HintQuestion placement="top-start">{helpText}</HintQuestion>
        </div>
    );
};

export default PremiumCheckbox;
